<router-outlet></router-outlet>
<button *ngIf="supportButton.visible && supportButton.initialized" mat-raised-button class="support-button" (click)="supportButton.toggle()">
    <mat-icon>support_agent</mat-icon>
    Support
</button>